import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Dialog } from '@progress/kendo-react-dialogs'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { Input } from '@progress/kendo-react-inputs'
import { Grid } from '@material-ui/core'
import LabelPure from '../label/label.pure'
import ButtonHLPure from '../buttonHL/buttonHL.pure'
import { useTranslation } from 'react-i18next'
import ModalUtil from '../modal/modal.util'
import './dialog-add-bot.css'

const DialogAddBotPure = ({ onClose, onSubmit, templates = [], loadingTemplates = false }) => {
  const modalUtil = new ModalUtil()
  const { t } = useTranslation()
  const { t: tCommon } = useTranslation('common')

  const templateOptions = templates.map(template => ({
    id: template.id,
    label: template.name,
    description: template.description
  }))

  const [selectedTemplate, setSelectedTemplate] = useState(templateOptions[0] || null)
  const [chatbotName, setChatbotName] = useState('')
  const [hoverTooltip, setHoverTooltip] = useState(null)

  useEffect(() => {
    if (!selectedTemplate && templateOptions.length > 0) {
      setSelectedTemplate(templateOptions[0])
    }
  }, [templates])

  const handleItemMouseEnter = (e, description) => {
    const rect = e.currentTarget.getBoundingClientRect()
    setHoverTooltip({
      text: description,
      top: rect.top,
      left: rect.right + 8
    })
  }

  const handleItemMouseLeave = () => {
    setHoverTooltip(null)
  }

  const templateItemRender = (li, itemProps) => {
    return React.cloneElement(li, {
      ...li.props,
      onMouseEnter: (e) => handleItemMouseEnter(e, itemProps.dataItem.description),
      onMouseLeave: handleItemMouseLeave
    })
  }

  const handleTemplateChange = (e) => {
    setSelectedTemplate(e.value)
  }

  const handleNameChange = (e) => {
    setChatbotName(e.value)
  }

  const handleSubmit = async () => {
    if (!chatbotName.trim()) {
      modalUtil.showModal('error', t('botConfig.modal.error.nameRequired'), t('modal.pure.title.error'))
      return
    }
    if (!selectedTemplate) {
      modalUtil.showModal('error', t('botConfig.modal.error.templateRequired'), t('modal.pure.title.error'))
      return
    }

    modalUtil.showModal('loading', t('modal.pure.loading.message'), t('modal.pure.loading.title'))

    try {
      await onSubmit({
        chatbotName: chatbotName.trim(),
        templateId: selectedTemplate.id
      })
      onClose()
    } catch (error) {
      modalUtil.showModal('error', error.message || t('modal.pure.title.error'), t('modal.pure.title.error'))
    }
  }

  return (
    <Dialog
      width={450}
      onClose={onClose}
      className="dialogFormHLPure-container dialog-add-bot"
      title={t('botConfig.modal.titleBotTemplate')}
    >
      <Grid container spacing={3}>
        {/* Input de Nombre del Bot */}
        <Grid item xs={12}>
          <LabelPure htmlFor="chatbot-name" title={t('botConfig.modal.label') || 'Nombre del Asistente'} />
          <Input
            id="chatbot-name"
            value={chatbotName}
            onChange={handleNameChange}
            className="eticket-input-field"
            placeholder={t('botConfig.modal.botTemplateNamePlaceholder') || 'Ej: Asistente de Ventas'}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        {/* Dropdown de Plantillas */}
        <Grid item xs={12}>
          <LabelPure htmlFor="template-dropdown" title={t('botConfig.modal.templateLabel') || 'Tipo de Asistente'} />
          <DropDownList
            id="template-dropdown"
            dataItemKey="id"
            textField="label"
            data={templateOptions}
            value={selectedTemplate}
            onChange={handleTemplateChange}
            itemRender={templateItemRender}
            className="eticket-dropdown-field"
            disabled={loadingTemplates}
          />
        </Grid>

        {/* Botones de Acción */}
        <Grid item xs={12} className="button-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
          <ButtonHLPure
            nameBtn={tCommon('cancel')}
            onClick={onClose}
            colorScheme="neutral"
          />
          <ButtonHLPure
            primary
            nameBtn={tCommon('create') || 'Crear'}
            onClick={handleSubmit}
            disabled={!chatbotName.trim() || !selectedTemplate || loadingTemplates}
          />
        </Grid>
      </Grid>

      {hoverTooltip && createPortal(
        <div
          className="dialog-add-bot-item-tooltip"
          style={{ top: hoverTooltip.top, left: hoverTooltip.left }}
        >
          {hoverTooltip.text}
        </div>,
        document.body
      )}
    </Dialog>
  )
}

export default DialogAddBotPure
